import { Content } from '../../types';

export const kohChangContent: Content = {
  title: "קו צ'אנג - אי של טבע קסום ונופש חלומי",
  imageUrl: '/images/thailand/koh-chang/koh-chang-wide.jpeg',
  introduction:
    "קו צ'אנג, האי השני בגודלו בתאילנד, ממוקם בדרום-מזרח מפרץ תאילנד, במחוז טראט. זהו אי קסום המשלב חופים מרהיבים, טבע פראי וכפרים מסורתיים, ההופכים אותו ליעד אטרקטיבי במיוחד עבור מטיילים המחפשים חוויית נופש מגוונת.",
  sections: [
    {
      title: "הטבע הפראי של קו צ'אנג",
      content:
        'לב האי מכוסה ביער גשם טרופי צפוף והררי, המהווה בית למגוון רחב של צמחייה ובעלי חיים. באי ניתן למצוא מספר מפלי מים יפיפיים, כאשר המפורסם והגדול שבהם הוא מפל Khlong Plu, הנחשב ליעד חובה למבקרים באי. מסלולי הליכה מרהיבים מובילים אל המפלים, שם ניתן להשתכשך במים הקרירים וליהנות מאווירה טבעית ומרגיעה.',
      type: 'text',
    },
    {
      title: "החופים היפים של קו צ'אנג",
      type: 'sub-headers',
      description:
        "קו צ'אנג מציע למבקרים חופים יפהפיים בעלי חול לבן ומי טורקיז צלולים. מרבית החופים התיירותיים נמצאים בצידו המערבי של האי, כאשר הפופולריים שבהם הינם:",
      content: [
        {
          subtitle: 'White Sand Beach',
          text: 'החוף המפורסם והמתוייר ביותר, עם מבחר רחב של מלונות, מסעדות, ברים ואטרקציות ימיות.',
        },
        {
          subtitle: 'Klong Prao Beach',
          text: 'חוף ארוך ושקט יותר, מתאים למשפחות ולמחפשי רוגע, עם נוף מרהיב ואווירה שלווה.',
        },
        {
          subtitle: 'הצד המזרחי של האי',
          text: 'פחות מתוייר ומאוכלס ברובו על ידי המקומיים, מה שמעניק לו אווירה אותנטית יותר.',
        },
      ],
    },
    {
      title: 'כפר הדייגים Bang Bao ותצפית Kai Bae',
      content:
        "בדרום האי שוכן כפר הדייגים Bang Bao, הבנוי על כלונסאות עץ מעל המים. זהו מקום ייחודי עם שוק מקומי נעים, הכולל חנויות מזכרות, מסעדות עם מאכלי ים טריים, בתי קפה ואף אפשרויות לינה. מהכפר יוצאות סירות טיולים לאיים סמוכים ולשוניות האלמוגים המרהיבות באזור.\n\nבדרך לכפר ניתן לעצור בנקודת התצפית Kai Bae, אחת מנקודות התצפית היפות באי, ממנה נשקף נוף עוצר נשימה של חופי קו צ'אנג והאיים הקטנים הסובבים אותו.",
      type: 'text',
    },
    {
      title: "דרכי הגעה לקו צ'אנג",
      type: 'sub-headers',
      description:
        'הגישה לאי הינה באמצעות מעבורת ממחוז טראט, כאשר לטראט, ניתן להגיע במספר דרכים:',
      content: [
        {
          subtitle: 'טיסות',
          text: 'קיימות טיסות ישירות מבנגקוק לטראט ומשדה"ת, נסיעה קצרה למזח המעבורות.',
        },
        {
          subtitle: 'אוטובוסים ומיניוואנים',
          text: 'יוצאים מבנגקוק לטראט בתדירות גבוהה.',
        },
        {
          subtitle: 'רכב פרטי',
          text: 'ניתן להגיע לטראט עם רכב פרטי ולהעביר אותו במעבורת לאי יחד עם הנוסעים.',
        },
      ],
    },
    {
      title: "מתי כדאי לבקר בקו צ'אנג?",
      content:
        "קו צ'אנג הינו יעד תיירותי שניתן לבקר בו לאורך כל השנה, אך התקופות המומלצות ביותר הן בין נובמבר לאפריל, כאשר מזג האוויר נעים ויבש יותר. החודשים מאי עד ספטמבר מאופיינים בגשמים כבדים יותר ולפיכך, פחות מומלצים עבור חופשה רגועה.",
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content:
        "בשורה התחתונה, קו צ'אנג מציע שילוב מושלם של טבע, חופים, תרבות ונופש והופך ליעד אידיאלי לכל סוגי המטיילים - ממשפחות וזוגות ועד תרמילאים ומטיילים עצמאיים. אם הינכם מחפשים חוויית אי מרהיבה, עם אווירה טרופית ייחודית - קו צ'אנג הינו המקום עבורכם!",
      type: 'text',
      isBold: true,
    },
  ],
};
